
define('AwaLabs.PartiesEvents', [
    'SC.Configuration',
    'PartiesEvents.View',
    'PartiesEvents.Model'
], function PartiesEventsModule(
    Configuration,
    PartiesEventsView,
    Model
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var route = Configuration.get('PartiesEventsConfig.url') || 'parties-events';
            var pageTypeComponent = container.getComponent('PageType');

            var pageType = {
                name: 'PartiesEvents',
                view: PartiesEventsView,
                routes: [route],
                options: {
                    model: new Model()
                },
                defaultTemplate: {
                    name: 'parties_events_form.tpl',
                    displayName: 'Parties Events Form'
                }
            };

            pageTypeComponent.registerPageType(pageType);
        }
    };
});
